import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d5268a08")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Tree = _resolveComponent("Tree")

  return (_openBlock(), _createBlock(_component_Tree, {
    id: "folders-tree",
    class: "kn-tree kn-column-tree kn-flex p-p-0",
    scrollHeight: "calc(100vh - 127px)",
    maximizable: "",
    value: _ctx.nodes,
    selectionMode: "single",
    selectionKeys: _ctx.selectedFolderKey,
    "onUpdate:selectionKeys": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedFolderKey = $event)),
    filter: true,
    filterMode: "lenient",
    expandedKeys: _ctx.expandedKeys,
    onNodeSelect: _ctx.setSelectedFolder,
    onNodeExpand: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOpenFolderIcon($event))),
    onNodeCollapse: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setClosedFolderIcon($event)))
  }, {
    default: _withId((slotProps) => [
      _createVNode("span", null, _toDisplayString(_ctx.getTranslatedLabel(slotProps.node.label)), 1)
    ]),
    _: 1
  }, 8, ["value", "selectionKeys", "expandedKeys", "onNodeSelect"]))
})